<template>
  <button
    :class="
      `button${navigation ? ' navigation' : ''}${
        language ? ' language' : ''
      } ${color}`
    "
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    color: String,
    language: Boolean,
    navigation: Boolean
  }
}
</script>

<style lang="scss">
.button {
  border: 2px solid #000000;
  background: #fff;

  color: #1d1d1b;

  transition: background 0.2s;

  &.color-1:hover {
    background: #c8ff00;
  }

  &.color-2:hover {
    background: #e673dc;
  }

  &.color-3:hover {
    background: #00f1b8;
  }

  &.color-4:hover {
    background: #5a7bff;
  }

  &.navigation {
    width: 178px;

    &:not(:first-child) {
      margin-left: 12px;
    }
  }

  &.language {
    width: 60px;

    &:not(:first-child) {
      margin-left: 12px;
    }
  }
}
</style>
